<button aria-label="star icon" class="resetStyles" (click)="toggleFav($event)" (keydown)="onKeyDownToggleFav($event)">
    <div class="icon" [ngClass]="{ active: isFavorite }" [innerHTML]="starIcon"></div>
</button>
